import React, { useEffect } from 'react';
import { Card, Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import CommonHeader from './CommonHeader';
import styles from './VerificationPending.module.scss';
import { getAgentSellerVerificationStatus } from '../api/marketplace';

const VerificationPending: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkVerificationStatus = async () => {
      try {
        const response = await getAgentSellerVerificationStatus();
        const status = response?.data?.status;
        
        if (status === 'Approved') {
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Failed to check verification status:', error);
      }
    };

    checkVerificationStatus();
  }, [navigate]);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="signup-container">
      <CommonHeader showNavigation={true} disableNavLinks={true} />
      
      <main className="signup-main profilePage">
        <div className={styles.verificationContainer}>
          <Card className={styles.verificationCard}>
            <div className={styles.verificationHeader}>
              <h1 className={styles.verificationTitle}>Verification Status</h1>
            </div>
            
            <div className={styles.statusSection}>
              <h2 className={styles.statusLabel}>Verification Pending</h2>
              
              <Alert
                message="Your Application is Currently Under Review, We'll Notify You Once it's Processed"
                type="warning"
                showIcon
                className={styles.statusAlert}
              />
              
              <div className={styles.reloadButtonContainer}>
                <Button
                  type="primary"
                  icon={<ReloadOutlined />}
                  onClick={handleReload}
                  size="large"
                >
                  Reload
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default VerificationPending;
